export const loginForm = {
  minimumCharacters: 5,
};
